module.exports = "<router-outlet></router-outlet>\r\n\r\n<!--<div class=\"build-version\" *ngIf='isQA'>Version #{{ buildVersion }}</div>-->\r\n<!--<app-footer></app-footer>-->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 1083
// module chunks = 1